import React from 'react';
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
const CustomAddButton = ({ label, Icon, onClick, isDisable = false }) => {
    return (
        <Button
            variant="outlined"
            startIcon={Icon ? <Icon /> : <AddIcon />}
            onClick={onClick}
            disabled={isDisable}
            sx={{
                width: '85px',
                height: '45px',
                fontWeight: 600,
                fontSize: '14px',
                lineHeight: '19.6px',
                letterSpacing: '2%',
                backgroundColor: '#006CB8',
                color: '#FFFFFF',
                borderColor: '#006CB8',
                padding: '1rem',
                width: '100%',
                borderRadius: 2,
                fontFamily: 'Inter',
                '&:hover': {
                    backgroundColor: '#005F8A',
                    borderColor: '#005F8A',
                },
                // Disabled style
                '&.Mui-disabled': {
                    backgroundColor: '#B0BEC5', // light grey background
                    color: '#ECEFF1',           // faded text
                    borderColor: '#B0BEC5',     // light grey border
                    cursor: 'not-allowed',
                },
            }}
        >
            {label}
        </Button>
    );
};

export default CustomAddButton;
